'use es6';

import PropTypes from 'prop-types';
import UISortableListComponent from 'ui-addon-draggable/components/UISortableList';
import UIDragList from 'ui-addon-draggable/list/UIDragList';
import connectDnd from 'ui-addon-draggable/decorators/connectDnd';
import { jsx as _jsx } from "react/jsx-runtime";
const ConnectedUISortableList = connectDnd(UISortableListComponent);
const UISortableList = props => /*#__PURE__*/_jsx(ConnectedUISortableList, Object.assign({}, props, {
  DragList: UIDragList
}));

// Adds prop descriptions to Storybook
UISortableList.propTypes = Object.assign({}, UISortableListComponent.propTypes, {
  /**
   * Whether items animate when reordered.
   */
  animate: PropTypes.bool,
  /**
   * Each child is a `UIDragListItem` with a unique `dragId`.
   */
  children: PropTypes.node,
  /**
   * The dragging direction. Pass in `className="display-flex justify-around"`
   * for horizontal cases.
   */
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * A unique string identifying the drag group.
   */
  dragGroup: PropTypes.string.isRequired,
  /**
   * Allows a connected `DragList` to be passed to the component, overriding the
   * default. `UISortableList` will connect components automatically so drag and
   * drop behaves as expected.
   *
   * In the event you need to pass in a connected drag
   * list, use `'ui-addon-draggable/list/UIDragList'`.
   * The unconnected versions of `UISortableList` and `UIDragList` are both
   * located in the `'ui-addon-draggable/components/'` directory, while
   * connected components are located in the `'ui-addon-draggable/list/'`
   * directory. For more details, see
   * [ui-addon-draggable#79](https://git.hubteam.com/HubSpot/ui-addon-draggable/pull/79).
   */
  DragList: PropTypes.elementType.isRequired,
  /**
   * Fired when the `order` changes.
   */
  onOrderChange: PropTypes.func,
  /**
   * An array containing each child `UIDragListItem`'s
   * `dragId`.
   */
  order: PropTypes.arrayOf(PropTypes.string)
});
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISortableList.defaultProps = Object.assign({}, UISortableListComponent.defaultProps);
export default UISortableList;